import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from "@angular/forms";
import { Subscription } from "rxjs";
import { Yii } from "libraries/interfaces/Yii";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { IDropOption } from "libraries/module/formbuilder/forms/searchAirTrip/searchAirTrip.component";
import { FlexibilityService } from "libraries/module/formbuilder/forms/searchAirTrip/services/flexibility.service";
import { wenji } from "libraries/interfaces/IWenji";
import { EAirSearchFields } from "app_locobook/air-search/e-air-search-fields";


export interface IAirSearchFlexibility {
    begin?: {
        plusOrMinus?: number;
    };
}

class Wording {
    public readonly flexibility: string = Yii.t('wui-shared-js', 'Flexibilité des départs');
}

@Component({
    selector: 'air-search-flexibility-form',
    templateUrl: './air-search-flexibility-form.component.html',
    styleUrls: ['./air-search-flexibility-form.component.scss']
})
export class AirSearchFlexibilityFormComponent implements OnInit, OnDestroy {
    public flexibilityFieldSpec: IFieldSpecs;
    public flexibilityItems: IDropOption[] = [];
    public airFlexibilitySearchForm: FormGroup;
    public wording: Wording = new Wording();
    public airSearchForm: FormGroup;

    public airSearchFlexibilityFormSubscription: Subscription;

    constructor(
        public flexibilityService: FlexibilityService,
        private formGroupDirective: FormGroupDirective,
        private fb: FormBuilder,
    ) {
    }

    public ngOnInit(): void {
        this.initAirSearchFlexibilityForm();
        this.initFlexibilityFieldSpec();
        this.initFlexibilityItems();
    }

    public ngOnDestroy(): void {
        this.airSearchForm.removeControl(EAirSearchFields.flexibility);
        if (this.airSearchFlexibilityFormSubscription) {
            this.airSearchFlexibilityFormSubscription.unsubscribe();
        }
    }

    private initAirSearchFlexibilityForm(): void {
        this.airFlexibilitySearchForm = this.fb.group({
            begin: this.fb.group({
                plusOrMinus: []
            })
        });
    }

    private initFlexibilityFieldSpec(): void {
        this.flexibilityFieldSpec = {
            formGroup: this.airFlexibilitySearchForm.get(EAirSearchFields.begin) as FormGroup,
            formControlName: EAirSearchFields.plusOrMinus,
            placeholder: this.wording.flexibility,
        };
        this.airSearchForm = this.formGroupDirective.form;
        this.airSearchForm.addControl(EAirSearchFields.flexibility, this.airFlexibilitySearchForm);
    }

    private initFlexibilityItems(): void {
        this.flexibilityItems = this.flexibilityService
            .getFlexibilityOptions(wenji?.locobook?.search?.departuresFlexibility);
    }

}
